import type { CharacterInfo } from "@/mocks/series";

interface CharacterCardProps {
  character: CharacterInfo;
}

export default function CharacterCard({ character }: CharacterCardProps) {
  return (
    <article className="w-40 shrink-0 overflow-hidden rounded-lg border border-background-200 bg-background-50 sm:w-auto">
      <div className="aspect-[4/5] w-full overflow-hidden bg-background-200">
        <img
          src={character.image}
          alt={`${character.name} 角色形象`}
          title={`${character.name} 角色介绍`}
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="p-3 md:p-4">
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="font-heading text-base font-semibold text-foreground-900">
            {character.name}
          </h3>
          <span className="whitespace-nowrap text-xs text-foreground-500">
            {character.actor}
          </span>
        </div>
        <p className="mt-2 text-xs leading-relaxed text-foreground-600">{character.desc}</p>
      </div>
    </article>
  );
}